import fetch from 'isomorphic-fetch';

export interface FetchWithTimeoutOptions extends RequestInit {
  timeout?: number;
}

export async function fetchWithTimeout(
  url: string,
  options: FetchWithTimeoutOptions = {},
): Promise<Response> {
  const { timeout, ...optionsWithoutTimeout } = options;

  if (!timeout) {
    return fetch(url, optionsWithoutTimeout);
  }

  const timeoutSignal = AbortSignal.timeout(timeout);
  optionsWithoutTimeout.signal = timeoutSignal as NonNullable<RequestInit['signal']>;

  return fetch(url, optionsWithoutTimeout).catch((error) => {
    if (error.name === 'AbortError' || error.name === 'TimeoutError') {
      const message = `${url} took too long to respond`;
      throw new Error(message);
    }

    throw error;
  });
}

export interface FetchJSONWithTimeoutOptions extends Omit<FetchWithTimeoutOptions, 'body'> {
  body?: Record<string, unknown>;
}

export const fetchJSONWithTimeout = (
  url: string,
  options: FetchJSONWithTimeoutOptions = {},
): Promise<Response> => {
  const { body, headers, ...fetchOptions } = options;

  return fetchWithTimeout(url, {
    ...fetchOptions,
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    ...(body && { body: JSON.stringify(body) }),
  });
};
